/**
 * Content Management API Service
 */

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const getToken = () => localStorage.getItem('admin_token');

async function fetchContentAPI(endpoint, options = {}) {
  const url = `${API_BASE_URL}/api${endpoint}`;
  const token = getToken();
  
  const headers = options.headers || {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (!headers['Content-Type'] && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, { ...options, headers });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
  }
  
  if (response.status === 204) return null;
  return response.json();
}

export const contentAPI = {
  // Get all editable pages
  getPages: () => fetchContentAPI('/content'),
  
  // Get content for a specific page
  getPageContent: (pageId) => fetchContentAPI(`/content/${pageId}`),
  
  // Update page content
  updatePageContent: (pageId, content) => fetchContentAPI(`/content/${pageId}`, {
    method: 'PUT',
    body: JSON.stringify({ content }),
  }),
  
  // Upload image
  uploadImage: async (file, pageId, contentKey) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('page_id', pageId);
    formData.append('content_key', contentKey);
    
    const token = getToken();
    const response = await fetch(`${API_BASE_URL}/api/content/upload-image`, {
      method: 'POST',
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
      body: formData,
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Upload failed');
    }
    
    return response.json();
  },
  
  // Get image URL
  getImageUrl: (filename) => `${API_BASE_URL}/api/content/images/${filename}`,
  
  // Reset page to defaults
  resetPage: (pageId) => fetchContentAPI(`/content/reset/${pageId}`, {
    method: 'POST',
  }),
};

export default contentAPI;
